<template>
    <div class="ChatPageContainer" :class="{closed: !contactsListOpened}">
        <div class="container">
            <a-tabs :tabs="getTabs" ref="tabs" v-model="currentTab" >
              <slot/>
            </a-tabs>
        </div>
        <div class="ChatPageContainer__in">
            <div class="ChatPageContainer__left" v-if="!ActiveTab.isSystemTab">
              <template v-if="ActiveTab?.ITEMS">
                <div v-for="item in ActiveTab?.ITEMS">
                  <UserContact
                      :user="{name: item.title, avatar: item.picture}"
                      :info="item"
                      @click.prevent="setChat(item)"
                      :stats="{time: item.dataSet, active:item.current, status: 'delivered', date: item.dataSet}"
                  />
                  <!--                status:sent|read|delivered-->
                </div>
              </template>
              <template v-else>
                <div class="emptyTextBlock">
                  {{params.messages.notChats}}
                </div>
              </template>
            </div>
            <div class="ChatPageContainer__right">
                <ChatWindow
                    @addMessage="addMessage"
                    @showMore="showMore"
                    :langMessage="params.messages"
                    :params="ActiveTab.CURRENT_CHAT"
                    ref="chatWindow"/>
            </div>
        </div>
    </div>
</template>

<script>
import {ref, onMounted, computed, nextTick} from "vue";
import TouchEvent from "../libs/TouchEvent";
import UserContact from "../components/chat/UserContact";
import ChatWindow from "../components/chat/ChatWindow";
import Offer from "../components/chat/Offer";
import {AStepper, useAProgressBar} from '../components/ui';
import { send } from '../services/api';
import ATabs from "../components/ui/ATabs";
import {useStore} from "vuex";

export default {
    name: "ChatPageContainer",
    components: {AStepper, ATabs, Offer, UserContact, ChatWindow},
    props:['params'],
    setup(props,ctx) {
        const $store = useStore()
        const currentTab = ref(0);
        const loading = ref(false);
        const tabs = ref(null);
        const chatWindow = ref(null);
        const paramsData = ref(props.params);
        const progress = useAProgressBar();
        const setChat = async (e) => {
          history.pushState(null, null, e.link);
          progress.show();

          await send(e.link, {method: "GET"}, {api:'y'}).then((response) => {
              chatWindow.value.scrollBottom()
            paramsData.value = response[props.params.responseKey];
            progress.hide();
          })
        };
        const swipeDirection = ref(null)
        const contactsListOpened = ref(true)
        const getTabs = computed(()=>{
          let t = [];
          for(let index in paramsData.value.tabs) {
            t[index] = paramsData.value.tabs[index]?.messages.title;

          }
          return t;
        });
        const ActiveTab = computed(()=> {
          return paramsData.value.tabs[currentTab.value];
        })
        const addMessage = async (e) => {
          let formData = new FormData();
          for(let index in ActiveTab.value.CURRENT_CHAT.api.addMessage.data) {
            formData.append(index,ActiveTab.value.CURRENT_CHAT.api.addMessage.data[index]);
          }
          if(e.file||e.text) {
            if(e.file) {
              formData.append('file',e.file);
            }
            if(e.text) {
              formData.append('text',e.text);
            }
            progress.show();
            await send(ActiveTab.value.CURRENT_CHAT.api.addMessage.link, {method: "POST"}, formData).then((response) => {
              if(response.messageInfo) {
                //paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS.push(response.messageInfo);
              }
                chatWindow.value.scrollBottom()
              progress.hide();
            })
          }

        };
        const showMore = async (params) => {
          if(!loading.value) {
            $store.commit('global/loaderStart')
            loading.value = true;
              console.log('showMore');
            const chatScrollElement = document.querySelector('.ChatWindow__in')

            await send(params.page, {method: "GET"}, {}).then((response) => {
              paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.PAGEN = response[props.params.responseKey].tabs[currentTab.value]['CURRENT_CHAT']['MESSAGES'].PAGEN;
              paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS =  [
                ...response[props.params.responseKey].tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS,
                ...paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS
              ];
              loading.value = false;
              $store.commit('global/loaderStop')

              if(chatScrollElement) {

                  nextTick(() => {
                      const header = document.querySelector('.header')
                      const el = document.getElementById(params.scrollElementId)
                      const rect = el.getBoundingClientRect()

                      el.scrollIntoView()
                      window.scrollTo(0, window.scrollY - header.clientHeight || 100)
                  })

              }
            })
          }

        }
        const updateCurentChat = async () =>{
          let d = JSON.parse(JSON.stringify(paramsData.value.tabs[currentTab.value].CURRENT_CHAT.api.getNewMessages.data));
          d.lastMessageId = 0;
          if(paramsData?.value?.tabs[currentTab.value]?.CURRENT_CHAT?.MESSAGES?.ITEMS) {
            let lastMessage = paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS[paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS.length-1];
            if(lastMessage!=undefined) {
              d.lastMessageId = lastMessage.id;
            }

          } else {
            paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS = [];
          }


          let formData = new FormData();
          for (let name in d) {
            formData.append(name,d[name]);
          }
          await send(
              paramsData.value.tabs[currentTab.value].CURRENT_CHAT.api.getNewMessages.link,
              {method: "POST"},
              formData
          ).then((response) => {
                paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS =  [
                  ...paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS,
                  ...response.ITEMS,
                ];
            setTimeout(()=>{
              updateCurentChat();
            },500);
          })
        }
        onMounted(() => {
            let touchEvent = null;
            const page = document.querySelector('.ChatPageContainer')

            page.addEventListener('touchstart', (event) => {
                touchEvent = new TouchEvent(event);
            });

            page.addEventListener('touchend', handleSwipe);

            for(let index in paramsData.value.tabs) {
                if(paramsData.value.tabs[index].active) {
                    currentTab.value = parseInt(index);
                }
            }


            function handleSwipe(event) {
                if (!touchEvent) {
                    return;
                }

                touchEvent.setEndEvent(event);

                if (touchEvent.isSwipeRight()) {
                    // Do something
                    contactsListOpened.value = true
                } else if (touchEvent.isSwipeLeft()) {
                    // Do something different
                    contactsListOpened.value = false
                }

                // Reset event for next touch
                touchEvent = null;
            }

            updateCurentChat();



        })


        return {
          currentTab,
          addMessage,
          showMore,
          getTabs,
          tabs,
          ActiveTab,
          setChat,
          swipeDirection,
          contactsListOpened,
          chatWindow,
        }
    }
}
</script>

<style lang="scss">
html.page_type_chat, body.page_type_chat {
    height: calc(100vh - 210px);

    @include mobile {
        height: calc(100vh - 150px);
    }
}
</style>

<style scoped lang="scss">
$contactsWidth: rem(385);
$contactsWidthTablet: rem(260);
$contactsWidthMobile: 100%;
.emptyTextBlock {
  width: 100%;
  height: 100%;
  text-align: center;
  color: #e9ebed;
  font-size: 2vw;

}
.emptyTextBlock:before {
  content: "";
  display: inline-block;
  width: 1px;
  margin-left: -1px;
  height: 100%;
  vertical-align: middle;
}
.ChatPageContainer {
    background-color: #fff;
    height: 100%;

    &__in {
        display: flex;
        overflow: hidden;
        width: 100%;
        height: 90vh;
        max-height: 90vh;

        @include mobile {
            width: 100vw;
        }
    }
    &__left {
        width: $contactsWidth;
        flex: 0 1 $contactsWidth;
        border-right: 1px solid var(--c-gray-600);
        margin-left: 0;
        transition: margin-left .5s;
        max-height: 100vh;
      overflow: auto;
        @include tablet {
            width: $contactsWidthTablet;
            flex: 0 1 $contactsWidthTablet;
        }

        @include mobile {
            width: $contactsWidthMobile;
            flex: 1 0 $contactsWidthMobile;
        }

        .closed & {
            margin-left: -$contactsWidth;

            @include tablet {
                margin-left: -$contactsWidthTablet;
            }

            @include mobile {
                margin-left: -$contactsWidthMobile;
            }
        }
    }

    &__right {
        flex: 1;
        border-top: 1px solid var(--c-gray-600);
        border-bottom: 1px solid var(--c-gray-600);
        max-height: 100vh;
        overflow: visible;

        @include mobile {
            width: 100%;
            flex: 0 1 100%;
        }


        .closed & {

        }
    }
}
</style>